// Site data: services, projects, industries, testimonials, values, stats
export const SITE = {
  name: "PHOS Management",
  tagline: "General Contractor · Southeast Michigan",
  contact: {
    email: "phosmangement@gmail.com",
    phone: "734-250-8485",
    address: "12200 Sibley Rd, Riverview, MI 48192",
    hours: "Mon–Fri · 7:00 AM – 6:00 PM",
  },
  socials: [
    { label: "LinkedIn", href: "#" },
    { label: "Instagram", href: "#" },
    { label: "Facebook", href: "#" },
  ],
};

export const STATS = [
  { value: "25+", label: "Years of Experience" },
  { value: "1,000+", label: "Projects Completed" },
  { value: "$180M", label: "Value Delivered" },
  { value: "98%", label: "On-Time Completion" },
];

export const TRUST_ITEMS = [
  "25+ Years Experience",
  "Licensed & Insured",
  "Commercial & Residential",
  "Construction Management",
  "Design-Build Capable",
  "Serving Southeast Michigan",
];

export const SERVICES = [
  {
    slug: "commercial-construction",
    number: "01",
    title: "Commercial Construction",
    short: "Ground-up commercial developments delivered with disciplined scheduling and precision execution.",
    scope: ["Office & Corporate", "Retail & Mixed-Use", "Medical & Municipal", "Hospitality"],
    image: "https://images.pexels.com/photos/14989321/pexels-photo-14989321.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "industrial-construction",
    number: "02",
    title: "Industrial Construction",
    short: "Heavy-duty industrial facilities engineered for uptime, safety, and long service life.",
    scope: ["Manufacturing", "Warehousing & Logistics", "Utility & Infrastructure", "Plant Expansions"],
    image: "https://images.pexels.com/photos/34550874/pexels-photo-34550874.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "commercial-build-outs",
    number: "03",
    title: "Commercial Build-Outs",
    short: "Tenant improvements and interior fit-outs completed on tight timelines without compromise.",
    scope: ["Corporate Interiors", "Restaurant Fit-Outs", "Medical Suites", "Retail Spaces"],
    image: "https://images.pexels.com/photos/36631701/pexels-photo-36631701.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "multifamily-renovations",
    number: "04",
    title: "Multifamily Renovations",
    short: "Full-scale apartment community upgrades with minimal disruption to residents and revenue.",
    scope: ["Unit Turns", "Amenity Overhauls", "Exterior Modernization", "Common Areas"],
    image: "https://images.pexels.com/photos/8961133/pexels-photo-8961133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "general-contracting",
    number: "05",
    title: "General Contracting",
    short: "Single-source responsibility from mobilization through punch list — one accountable partner.",
    scope: ["Full Project Delivery", "Subcontractor Management", "Cost Control", "Quality Assurance"],
    image: "https://images.pexels.com/photos/3325648/pexels-photo-3325648.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "construction-management",
    number: "06",
    title: "Construction Management",
    short: "Pre-construction planning and CM-at-risk services aligning cost, schedule, and quality.",
    scope: ["Pre-Construction", "Value Engineering", "Owner Representation", "Scheduling"],
    image: "https://images.pexels.com/photos/7108784/pexels-photo-7108784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "design-build",
    number: "07",
    title: "Design-Build",
    short: "Integrated design and construction under one contract — faster, cleaner, more predictable.",
    scope: ["Unified Team", "Fast-Track Delivery", "Single Point of Contact", "Reduced Change Orders"],
    image: "https://images.pexels.com/photos/8482646/pexels-photo-8482646.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "concrete-masonry",
    number: "08",
    title: "Concrete & Masonry",
    short: "Structural concrete, foundations, and masonry work executed to exacting engineering tolerances.",
    scope: ["Foundations", "Slabs & Decks", "Site Concrete", "Block & Brick"],
    image: "https://images.pexels.com/photos/14989321/pexels-photo-14989321.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "roofing",
    number: "09",
    title: "Roofing",
    short: "Commercial and industrial roofing systems built for Michigan weather and 30-year lifespans.",
    scope: ["TPO & EPDM", "Metal Roofing", "Roof Restoration", "Emergency Repair"],
    image: "https://images.pexels.com/photos/34550874/pexels-photo-34550874.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    slug: "siding",
    number: "10",
    title: "Siding & Envelope",
    short: "Building envelope work that protects your investment and elevates curb appeal.",
    scope: ["Fiber Cement", "Metal Panels", "EIFS", "Weatherproofing"],
    image: "https://images.pexels.com/photos/36631701/pexels-photo-36631701.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const PROJECTS = [
  {
    id: "riverview-commerce",
    name: "Riverview Commerce Center",
    industry: "Commercial",
    scope: "Ground-Up · 84,000 sq ft",
    location: "Riverview, MI",
    year: "2024",
    image: "https://images.pexels.com/photos/14989321/pexels-photo-14989321.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
  {
    id: "detroit-industrial",
    name: "Detroit Industrial Park",
    industry: "Industrial",
    scope: "Facility Expansion · 210,000 sq ft",
    location: "Detroit, MI",
    year: "2024",
    image: "https://images.pexels.com/photos/34550874/pexels-photo-34550874.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
  {
    id: "trenton-multifamily",
    name: "The Trenton Residences",
    industry: "Multifamily",
    scope: "Community Renovation · 340 Units",
    location: "Trenton, MI",
    year: "2023",
    image: "https://images.pexels.com/photos/8961133/pexels-photo-8961133.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
  {
    id: "southgate-medical",
    name: "Southgate Medical Plaza",
    industry: "Commercial",
    scope: "Interior Build-Out · 32,000 sq ft",
    location: "Southgate, MI",
    year: "2023",
    image: "https://images.pexels.com/photos/36631701/pexels-photo-36631701.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
  {
    id: "wyandotte-retail",
    name: "Wyandotte Retail Row",
    industry: "Commercial",
    scope: "Mixed-Use · 6 Storefronts",
    location: "Wyandotte, MI",
    year: "2023",
    image: "https://images.pexels.com/photos/3325648/pexels-photo-3325648.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
  {
    id: "monroe-warehouse",
    name: "Monroe Logistics Hub",
    industry: "Industrial",
    scope: "New Construction · 145,000 sq ft",
    location: "Monroe, MI",
    year: "2022",
    image: "https://images.pexels.com/photos/7108784/pexels-photo-7108784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
  {
    id: "grosse-ile-estate",
    name: "Grosse Ile Custom Estate",
    industry: "Residential",
    scope: "Custom Build · 8,400 sq ft",
    location: "Grosse Ile, MI",
    year: "2023",
    image: "https://images.pexels.com/photos/8482646/pexels-photo-8482646.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
  {
    id: "taylor-mixed",
    name: "Taylor Mixed-Use Development",
    industry: "Commercial",
    scope: "Ground-Up · 5 Stories",
    location: "Taylor, MI",
    year: "2022",
    image: "https://images.pexels.com/photos/14989321/pexels-photo-14989321.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400",
  },
];

export const INDUSTRIES = [
  { title: "Apartment Communities", count: "120+", note: "Renovations, turns, common areas" },
  { title: "Industrial Facilities", count: "80+", note: "Manufacturing & warehousing" },
  { title: "Commercial Properties", count: "65+", note: "Ground-up & tenant improvement" },
  { title: "Office Buildings", count: "40+", note: "Corporate interiors" },
  { title: "Retail", count: "55+", note: "Storefronts & mixed-use" },
  { title: "Restaurants", count: "22+", note: "Full-service fit-outs" },
  { title: "Medical", count: "18+", note: "Clinics & suites" },
  { title: "Municipal", count: "12+", note: "Public sector work" },
  { title: "Residential", count: "60+", note: "Custom & renovation" },
];

export const VALUES = [
  { n: "01", title: "Integrity", body: "We do what we said we would do — at the price we quoted, on the day we promised. No exceptions, no excuses." },
  { n: "02", title: "Communication", body: "Owners, architects, and subs get one clear signal. Weekly reports, live schedules, one number to call." },
  { n: "03", title: "Safety", body: "Zero-incident culture through daily huddles, JHA discipline, and safety-first subcontractor vetting." },
  { n: "04", title: "Experienced Leadership", body: "Every project runs under a Senior PM with 15+ years on active job sites — not a fresh hire from a spreadsheet." },
  { n: "05", title: "Quality Craftsmanship", body: "We build to last. Every weld, every pour, every finish inspected against the spec — not the shortcut." },
  { n: "06", title: "Reliable Scheduling", body: "Detailed CPM schedules, proactive procurement, and a track record: 98% on-time delivery over 25 years." },
  { n: "07", title: "Long-Term Relationships", body: "Most of our work is repeat business. Owners who trust us once bring us their next three projects." },
];

export const TESTIMONIALS = [
  {
    quote: "PHOS delivered our 84,000 sq ft commerce center two weeks ahead of schedule with zero safety incidents. Their communication was unmatched — I always knew where every dollar and day were.",
    author: "David M.",
    title: "Owner, Riverview Commerce",
  },
  {
    quote: "Twenty-two months, three phases, occupied buildings the entire time. PHOS pulled off a multifamily renovation without a single tenant complaint escalating. That is craftsmanship and coordination.",
    author: "Sarah L.",
    title: "Asset Manager, Trenton Residences",
  },
  {
    quote: "We've built four projects with PHOS. Every one came in on budget, every one on time, every one to spec. That consistency is why we don't bid the work anymore — we just call them.",
    author: "James R.",
    title: "Director of Development, Detroit Industrial",
  },
];

export const POSITIONS = [
  { title: "Senior Project Manager", type: "Full-time · Riverview, MI", desc: "Lead $10M+ commercial projects end-to-end." },
  { title: "Superintendent — Commercial", type: "Full-time · Field", desc: "Day-to-day site leadership across Southeast Michigan." },
  { title: "Estimator", type: "Full-time · Riverview, MI", desc: "Pre-construction estimating and bid packaging." },
  { title: "Site Safety Manager", type: "Full-time · Field", desc: "OSHA compliance and job site safety programs." },
  { title: "Carpenter — Foreman", type: "Full-time · Field", desc: "Commercial framing and finish carpentry crews." },
  { title: "Assistant Project Manager", type: "Full-time · Riverview, MI", desc: "Support PMs with RFIs, submittals, and scheduling." },
];

export const LEADERSHIP = [
  { name: "Michael Phos", role: "President & Founder", bio: "Twenty-five years in Southeast Michigan construction. Started swinging a hammer, now runs one of the region's most trusted GCs." },
  { name: "Anthony R.", role: "VP of Construction", bio: "Twenty years leading complex commercial and industrial builds. Detail-obsessed schedule engineer." },
  { name: "Michelle K.", role: "Director of Preconstruction", bio: "Fifteen years in estimating and value engineering. Turns rough concepts into predictable budgets." },
  { name: "Robert T.", role: "Safety Director", bio: "Certified CHST. Ten years of zero-incident sites across dozens of active projects." },
];
